import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import CheckBoxType from '@/Controls/CheckBox';
import LabelType from '@/Controls/Label';

export default class AssociationCheckBox extends Control {

    private CheckBox = ComponentManager.getControl<typeof CheckBoxType>('CheckBox');
    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery;
    private label: LabelType;
    private elements: Array<CheckBoxType>;

    public constructor(private viewModel, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div><div class="c-iterator"><div><input type="checkbox"><div class="element"></div></div></div></div>');

        this.widget(null);

        $('<div class="clear">').appendTo(this.jQueryControl);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'associationcheckbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });
        let timeout;
        let timeoutCallback = () => {
            this.viewModel.isBusy(false);
        }
        this.elements = [];
        this.applyBindings(this.jQueryControl.find('.c-iterator'), {
            foreach: {
                data: this.viewModel.data,

                afterRender: (elements, checkBoxViewModel) => {
                    if (!this.viewModel.isBusy()) {
                        this.viewModel.isBusy(true);
                    }
                    for (let i = 0; i < elements.length; i++) {
                        let checkBox = new this.CheckBox(checkBoxViewModel, $(elements[i]));
                        let tuple = checkBox.getTuple();

                        this.elements.push(checkBox);
                    }

                    if (timeout !== undefined) {
                        clearTimeout(timeout);
                    }
                    timeout = this.async(timeoutCallback, 500);
                }
            }
        });

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label);
            let tuple = this.label.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('AssociationCheckBox', AssociationCheckBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setControl('AssoziationCheckBox', AssociationCheckBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');